import { render } from "./EmployeesDaysOff.vue?vue&type=template&id=00253d21&scoped=true"
import script from "./EmployeesDaysOff.vue?vue&type=script&lang=js"
export * from "./EmployeesDaysOff.vue?vue&type=script&lang=js"

import "./EmployeesDaysOff.vue?vue&type=style&index=0&id=00253d21&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00253d21"]])

export default __exports__